<label for="selectPage">Filas por página</label>
<select class="selectPageSize form-control" [(ngModel)]="pageSize" (change)="pageSizeChanged()">
  <option 
      *ngFor="let option of pageSizeOptions"
      [ngValue]="option">{{option}}</option>
</select>
